module.exports = __webpack_public_path__ + "static/Signage-c313286c6880b4c2f543f778118a912c.svg";